import { Users } from 'lucide-react'
import { useState } from 'react'

import FilterManagementDropdown from 'components/brokers/needs_attention/FilterManagementDropdown'
import { filterByLabelAndValueCallback } from 'components/brokers/needs_attention/utils'
import { type MultipleSelectedValuesFilter } from 'components/brokers/types'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from 'components/reusable/table/ComboboxMultiSelectFilter'

const EmployerOECohortFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const cohortOptions: ComboboxFilterOption<string>[] = [
    // Renewal cohorts
    { label: 'Renewal Self Serve', value: 'renewal_self_serve' },
    { label: 'Renewal High Touch', value: 'renewal_high_touch' },
    { label: 'Renewal Custom', value: 'renewal_custom' },
    { label: 'Renewal Sales', value: 'renewal_sales' },
    // New employer cohorts
    { label: 'New Employer Self Serve', value: 'new_employer_self_serve' },
    { label: 'New Employer Sales', value: 'new_employer_sales' },
  ]

  const filteredOptions = cohortOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[{ groupLabel: 'Cohort', options: filteredOptions || [] }]}
        placeholder='Search cohorts to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={cohortOptions || []}
          noSelectionText='Cohort'
          pluralIdentifier='cohorts'
        >
          <Users size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default EmployerOECohortFilter
